
export default {
    selector: "g.pt-tag",
    listeners: {
        mouseenter: true,
        mouseleave: true,
        click: true
    }
}
